<h2 mat-dialog-title>
  Offer-{{ matchedOffer?.offer_number }} Bid History
</h2>
<mat-dialog-content>
  <table
    mat-table
    matSort
    matSortActive="created"
    matSortDirection="desc"
    [dataSource]="dataSource"
    class="bid-history-table">

    <ng-container matColumnDef="created">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
      <td mat-cell *matCellDef="let row">
        @if (row.created) {
          <div class="text-ellipsis">
            <div class="text-ellipsis" [title]="row.created | epoch:'L'">{{ row.created | epoch:'L' }}</div>
            <small class="text-ellipsis text-gray" [title]="row.created | epoch:'LT'">{{ row.created | epoch:'LT' }}</small>
          </div>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
      <td mat-cell *matCellDef="let row">
        @if (isFormula) {
          {{ getSign(row.amount) }}{{ getAbsolutePrice(row.amount) | number:'1.4-4' }} {{ row.currency }}
        } @else {
          {{ row.amount | number:'1.4-4' }} {{ row.currency }}
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Active</th>
      <td mat-cell *matCellDef="let row">{{ row.active ? 'Yes' : 'No' }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell text-center text-muted" [attr.colspan]="displayColumns.length">
        No bid history
      </td>
    </tr>
  </table>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">CLOSE</button>
</mat-dialog-actions>
